import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-05f997ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "container_box"
}
const _hoisted_5 = { class: "container_left" }
const _hoisted_6 = { class: "problems" }

import { ref, onMounted } from 'vue'
  import axios from 'axios'
  import UserInfo from '@/components/user-info.vue'
  import Item from '@/components/item.vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import {useRouter} from 'vue-router'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  const router = useRouter();
  const { params } = router.currentRoute.value
  
  let answerDetails:any = []
  const qList:any = ref([])
  const examinationRecordId:string = params.enrollId
  const planId:string = params.planId
  const examConfig:any = ref({})
  const planInfo:any = ref({})
  const examinationInfo:any = ref({})
  const isLoading:boolean = ref(true)
  const questionList:any = []

  onMounted(() => {
    getTrainPlan()
  })

  const getExaminationRecord = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true, text: '获取的考卷...' })
    let { data } = await axios.get(`/api/exam-end/getExamination/${examinationRecordId}`)
    loadingInstance.close()
    if ( data.code === 200 ) {
      examinationInfo.value = data.data
      getAnswerDetails(data.data)
    }
  }

  const getTrainPlan = async () => {
    let { data } = await axios.get(`/api/exam-end/trainPlan/${planId}`)
    if ( data.code === 200 ) {
      examConfig.value = data.data
      planInfoHandler()
    }
  }

  const planInfoHandler = async () => {
    let { data } = await axios.get(`/api/exam-end/plan/${planId}`)
    if ( data.code === 200 ) {
      planInfo.value = data.data
      getExaminationRecord()
    }
  }

  const getAnswerDetails = async (item:any) => {
    let { data } = await axios.get(`/api/exam-end/answer/${item.id}`)
    if ( data.code === 200 ) {
      answerDetails = data.data
      getAnswer(item)
    }
  }

  const getAnswer = async (item:any) => {
    if ( qList.value.length > 0 ) {
      ElMessage.error("已获取过试卷，请勿重复获取！")
      return
    }
    let { data }  = await axios.get(`/api/exam-end/question/${item.id}`)
    isLoading.value = false;
    if ( data.code === 200 ) {
      if ( data.rows.length ) {
        data.rows.map((item:any) => {
          item.questionSnapshots = JSON.parse(item.questionSnapshots)
          item.questionAnswer = []
          let answerList = []
          let list = []
          let temp = answerDetails.find((q:any) => q.questionSnapshotsId === item.id)
          if ( temp ) {
            let answer = JSON.parse(temp.answer)
            if ( answer.length > 0 ) {
              item.answerList = answer
            }
            list = temp.answer
          }
          let idx = 1
          for ( let n in item.questionSnapshots ) {
            if ( /answer\d/.test(n) ) {
              if ( list.includes(idx) ) {
                answerList.push({ title: item.questionSnapshots[n], isFlag: true })
              } else {
                answerList.push({ title: item.questionSnapshots[n], isFlag: false })
              }
              idx++
            }
          }
          item.answers = answerList
          item.answerList = []
          item.questionType = item.questionSnapshots.questionType
          return item
        })
        qList.value = data.rows;
      } else {
        ElMessage.error("未获取到相关试卷！")
      }
      
    } else {
      ElMessage.error("未获取到相关试卷！")
    }
  }

  // const retryHandler = async () => {
  //   qList.value = []
  //   isShowScore.value = false
  //   index.value = 0
  //   let { data } = await axios.post(`/api/exam-end-mock/remove/examrecord/${examinationRecordId}/${params.postionType}/${params.stageCode}`);
  //   if ( data.code === 200 ) {
  //     getAnswer()
  //   }
  // }

  window.onbeforeunload = function() {
    console.log('beforeunload')
    return 1;
  };

return (_ctx: any,_cache: any) => {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(UserInfo, { data: qList.value }, null, 8, ["data"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_main, { class: "content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, {
                      class: "bg-color",
                      justify: "center"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qList.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "item",
                            key: index
                          }, [
                            (_openBlock(), _createBlock(Item, {
                              noClick: true,
                              data: item,
                              index: index,
                              key: index,
                              examinationRecordId: _unref(examinationRecordId)
                            }, null, 8, ["data", "index", "examinationRecordId"]))
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})